import Tone from 'tone'

export default ([
  {
    id: 1,
    name: 'Classic',
    playing: false,
    track: new Tone.Player({
      url: './GoodBeats2Use/beat1.mp3',
      fadeIn: 0.1,
      fadeOut: 0.1,
      loop: true
    }).toMaster()
  },
  {
    id: 2,
    name: 'Stutter',
    playing: false,
    track: new Tone.Player({
      url: './GoodBeats2Use/beat2.mp3',
      fadeIn: 0.1,
      fadeOut: 0.1,
      loop: true
    }).toMaster()
  },
  {
    id: 3,
    name: 'Heavy',
    playing: false,
    track: new Tone.Player({
      url: './GoodBeats2Use/beat3.mp3',
      fadeIn: 0.1,
      fadeOut: 0.1,
      loop: true
    }).toMaster()
  },
  {
    id: 4,
    name: 'Dreamy',
    playing: false,
    track: new Tone.Player({
      url: './GoodBeats2Use/beat4.mp3',
      fadeIn: 0.1,
      fadeOut: 0.1,
      loop: true
    }).toMaster()
  },
  {
    id: 5,
    name: 'Spooky',
    playing: false,
    track: new Tone.Player({
      url: './GoodBeats2Use/beat5.mp3',
      fadeIn: 0.1,
      fadeOut: 0.1,
      loop: true
    }).toMaster()
  },
  {
    id: 6,
    name: 'Reggae',
    playing: false,
    track: new Tone.Player({
      url: './GoodBeats2Use/beat6.mp3',
      fadeIn: 0.1,
      fadeOut: 0.1,
      loop: true
    }).toMaster()
  },
  {
    id: 7,
    name: 'Melodic',
    playing: false,
    track: new Tone.Player({
      url: './GoodBeats2Use/beat7.mp3',
      fadeIn: 0.1,
      fadeOut: 0.1,
      loop: true
    }).toMaster()
  },
  {
    id: 8,
    name: 'Strings',
    playing: false,
    track: new Tone.Player({
      url: './GoodBeats2Use/beat8.mp3',
      fadeIn: 0.1,
      fadeOut: 0.1,
      loop: true
    }).toMaster()
  },
  {
    id: 9,
    name: 'Dance',
    playing: false,
    track: new Tone.Player({
      url: './GoodBeats2Use/beat9.mp3',
      fadeIn: 0.1,
      fadeOut: 0.1,
      loop: true
    }).toMaster()
  },
  {
    id: 10,
    name: 'Trance',
    playing: false,
    track: new Tone.Player({
      url: './GoodBeats2Use/beat10.mp3',
      fadeIn: 0.1,
      fadeOut: 0.1,
      loop: true
    }).toMaster()
  }
])


// WEBPACK FOOTER //
// ./src/GoodBeat/goodBeatData.js